export default "__VITE_ASSET__ff8f68e9__"